<template>
  <v-container grid-list-md>
    <v-card>
      <v-card-title>
        Debts List
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-cloud-search-outline"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :loading="isLoading"
        :no-data-text="noData"
        :headers="headers"
        :items="CustomersList"
        :search="search"
      >
        <template v-slot:item.blc="{ item }">
          <v-btn
            :id="item.AccountNumber"
            color="success"
            :loading="clickedID === item.AccountNumber ? true : false"
            icon
            class="text-capitalize primary-text"
            @click="ShowBalance(item)"
          >
            <v-icon small>mdi-cash-multiple</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Balance Dialog -->
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card v-if="Balance.length > 0">
          <v-card-title class="headline justify-center">{{
            Balance.Name
          }}</v-card-title>

          <v-card-text class="font-weight-black title text-center">
            <template v-for="(item, index) in Balance">
              <p
                v-if="item.Amount != 0"
                :key="index"
                :class="{ 'red--text': item.loan == 'yess' ? true : false }"
              >
                {{ item.AmountType }}: {{ item.Amount.toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </p>
            </template>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-card-title class="headline justify-center">{{
            Balance.Name
          }}</v-card-title>

          <v-card-text class="font-weight-black title text-center">
            Empty Balance
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      isLoading: true,
      noData: "No debts availible",
      CustomersList: [],
      dialog: false,
      dialog2: false,
      clickedID: "",
      Balance: [],
      search: "",
      headers: [
        {
          text: "Full Name",
          align: "left",
          value: "FullName",
        },
        { text: "Phone", value: "Cusphone" },
        { text: "Account", value: "AccountNumber" },
        { text: "ID Number", value: "IDNomber", sortable: false },
        { text: "Balance", value: "blc", align: "center", sortable: false },
      ],
    };
  },
  computed: {},
  methods: {
    ShowBalance(item) {
      this.clickedID = item.AccountNumber;
      this.Balance = [];
      // console.log(ID);
      this.$store
        .dispatch("INSERT_ONLY", {
          url: "/customer/balance",
          data: {
            AccountNumber: item.AccountNumber,
          },
        })
        .then(result => {
          this.clickedID = "";
          // console.log(result);
          if (result.status === 200) {
            this.dialog = true;
            this.Balance = result.data;
            this.Balance.Name = item.FullName;
          }
        })
        .catch(() => {
          // console.log(error);
          this.clickedID = "";
        });
    },
    LoadDepts() {
      this.$store
        .dispatch("GET_DATA_ONLY", "/customer/debts")
        .then(result => {
          this.CustomersList = result.data;
          this.isLoading = false;
          this.noData = "No debts availible";
          // console.log(result);
        })
        .catch(() => {
          this.isLoading = false;
          this.noData =
            "something is wrong blease refresh the page and check the internet connection";
          // console.log(error);
        });
    },
  },
  created() {
    this.LoadDepts();
  },
};
</script>
